/**
 * What the canvas is rooted on: the whole page, or a single entity isolated
 * from it.
 *
 * The three canvas views (page, Section, frame) differ by this and little else,
 * and both hosts - a Share and a Preview - express it the same way. Deriving it
 * once, from the route, is what lets a single canvas serve all six.
 */
export type CanvasFocus =
  | { kind: 'page' }
  | { kind: 'section'; uuid: string }
  | { kind: 'frame'; uuid: string }

export interface CanvasScope {
  /** The page whose presentation file the canvas is showing. */
  pageUUID: string
  focus: CanvasFocus
  /**
   * The focused entity - the renderer's scene root - or undefined on the page
   * canvas. Shorthand for the `uuid` of a non-page focus, which is what most
   * consumers actually want.
   */
  entityUUID: string | undefined
}

/** Shared instance so a page focus keeps a stable identity across renders. */
export const PAGE_FOCUS: CanvasFocus = { kind: 'page' }
